import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const GhostedCheckbox = ({
  isChecked,
  onChange
}) => {
  return /*#__PURE__*/_jsx(FormControl, {
    children: /*#__PURE__*/_jsx(Checkbox, {
      checked: isChecked,
      "data-test-id": "ghosted-checkbox",
      description: /*#__PURE__*/_jsx(HelpIcon, {
        "data-test-id": "checkbox-help",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "checkbox-tooltip",
          message: "app.taxonomy.panel.ghosted.tooltip"
        }),
        tooltipPlacement: "bottom"
      }),
      descriptionLayout: "horizontal",
      onChange: ({
        target: {
          checked
        }
      }) => {
        onChange(checked);
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "checkbox-label",
        message: "app.taxonomy.panel.ghosted.label"
      })
    })
  });
};
GhostedCheckbox.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};
export default GhostedCheckbox;